import { render, staticRenderFns } from "./AppTabSet.vue?vue&type=template&id=51b5c684&"
import script from "./AppTabSet.vue?vue&type=script&lang=js&"
export * from "./AppTabSet.vue?vue&type=script&lang=js&"
import style0 from "./AppTabSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports